import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { useStateContext } from '../../contexts/ContextProvider';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#A569BD'];

const Doughnut = ({ id, data = [], legendVisiblity = true, height = 300 }: any) => {
  const { currentMode } = useStateContext();

  // Map data to { name, value, text }
  const mapped = data.map((d: any) => ({ name: d.x, value: Number(d.y), text: d.text }));

  return (
    <div id={id} style={{ width: '100%', height }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Legend verticalAlign="top" align="center" wrapperStyle={{ display: legendVisiblity ? 'block' : 'none', color: currentMode === 'Dark' ? '#eee' : '#333' }} />
          <Tooltip contentStyle={{ backgroundColor: currentMode === 'Dark' ? '#1f2937' : '#fff', borderRadius: 6 }} />
          <Pie data={mapped} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={height * 0.2} outerRadius={height * 0.35} label>
            {mapped.map((entry: any, index: number) => (
              <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default Doughnut;
